<div class="w-full flex justify-content-center width-90rem">
    <div class="card w-5">
<!--        <button class="flex p-button p-button-secondary p-1 mb-2" (click)="activeStep = 1">-->
<!--            <i class="pi pi-arrow-left mr-2"></i>-->
<!--            <span>{{'sipo.back' | translate}}</span>-->
<!--        </button>-->
        <!--package name begin-->
        <div class="mb-2  text-center">
            <div class="text-4xl font-bold">
                {{ selectedPackage.name }}
            </div>
            <div class="border-round-lg p-2  text-center" [ngClass]="selectedPackage.name === 'Starter' ? 'bg-gray-100' : 'bg-secondary'">
                {{ selectedPackage.topBadgeInfo }}
            </div>
        </div>
        <!--package name end-->
        <!--package description begin-->
        <div class="mb-4 text-lg  text-center ">
            {{ selectedPackage.planUsageInfo | translate }}
        </div>
        <!--package description end-->
        <!--package price begin-->
        <div class="text-3xl font-bold pb-5  text-center">
            <span
                *ngIf="isYearly">{{ selectedPackage.priceYearly | number:'1.2-2' }} {{ selectedPackage.currency | currencySymbol }}
                / {{ 'sipo.payment-component.year' | translate }}</span>
            <span
                *ngIf="!isYearly">{{ selectedPackage.priceMonthly | number:'1.2-2' }} {{ selectedPackage.currency | currencySymbol }}
                / {{ 'sipo.payment-component.month' | translate }}</span>
        </div>
        <p-divider></p-divider>
        <!--package price end-->
        <div class="mb-2 text-lg"  *ngIf="isYearly">{{ selectedPackage.earlyBird | translate }}</div>
        <!--package content begin-->
        <div class="mb-4">
            <ul class="pl-4">
                <li class="py-2 text-1xl" *ngFor="let c of selectedPackage.contents">
                    {{ c }}
                </li>
            </ul>
        </div>
        <!--package content end-->
        <!--confirm button begin-->
        <div class="w-full mb-2">
            <button (click)="nextStep()"
                    class="w-full p-button bg-secondary flex justify-content-center">
                {{ 'sipo.payment-component.buy-now' | translate }}
            </button>
        </div>
        <!--confirm button end-->
        <!--payment methods begin-->
        <div class="flex justify-content-between align-items-center text-xl">
            <div class="w-12 text-center">
                <img class="w-3" src="assets/images/payment/visa.svg">
                <img class="w-2" src="assets/images/payment/mastercard.svg">
                <img class="w-3" src="assets/images/payment/paypal-multicolor.svg">
            </div>

        </div>
        <!--payment methods end-->
    </div>
</div>
